/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandDeliveroo = createReactComponent("outline", "brand-deliveroo", "IconBrandDeliveroo", [["path", { "d": "M15 11l1 -9l5 .5l-1 13.5l-3 6l-12.5 -2.5l-1.5 -6l7 -1.5l-1.5 -7.5l4.5 -1z", "key": "svg-0" }], ["circle", { "cx": "15.5", "cy": "15.5", "r": "1", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "11.5", "cy": "14.5", "r": "1", "fill": "currentColor", "key": "svg-2" }]]);

export { IconBrandDeliveroo as default };
//# sourceMappingURL=IconBrandDeliveroo.mjs.map
